require('dotenv').config()

const prod = {
    api: {
        URL: '/api'
    },
};

const dev = {
    api: {
        URL: 'http://localhost:8000/api'
    },
};

const config = process.env.REACT_APP_STAGE === 'staging'
    ? dev
    : prod;

    
export const appConfig = {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};